import { z } from 'zod';

export const PlatformSchema = z.enum(['twitch', 'youtube']);
export type Platform = z.infer<typeof PlatformSchema>;

/**
 * Ordem de desempate quando duas mensagens carregam o mesmo timestamp,
 * para que o feed unificado seja determinístico entre re-renders.
 * Ver `docs/architecture/2026-05-15-frontend-constraints.md` §3b.
 */
export const PLATFORM_PRIORITY: Record<Platform, number> = {
  twitch: 1,
  youtube: 2,
};
